import {IDotRezPartialBookingSessionData} from "../../../../dot-rez-api/data-contracts/booking/dot-rez-booking-session-data.interface";
import {IDotRezSsrToAdd} from "../../../../dot-rez-api/data-contracts/requests/booking/update-ssrs.request";
import {BookingMutationActionBase} from "../booking-mutation-action-base";
import {InsuranceFeeNote} from "../../insurance/insurance-fee-note.model";
import {BookingModel} from "../../booking.model";
import {IMutationOptions} from "../mutation-options.interface";
import {IInsuranceProductModel} from "../../insurance/models/insurance-product.model.interface";
import {
    IBookingMultipleFeesOverrideRequest
} from "../../../../airline-webapi/requests/booking-multiple-fees-override.request";
import {PassengerFeeModel} from "../../fees/passenger/passenger-fee.model";


interface IInsuranceFeeDescriptor {
    passengerKey: string;
    amount: number;
    note: string;
    existingFee: PassengerFeeModel | null;
}


export class SellInsuranceMutation extends BookingMutationActionBase {

    constructor(private readonly product: IInsuranceProductModel,
                booking: BookingModel,
                options?: IMutationOptions) {
        super(booking, options);
    }

    protected _getInsuranceFees(): IInsuranceFeeDescriptor[] {


        let feesToAdd: IInsuranceFeeDescriptor[] = [];

        //let remainingPremiumAmount = this.product.totalPremium;

        for(let passenger of this.booking.passengers) {

            let feeAmount = this.product.getPremiumPerPassengerType(passenger.passengerType);
            if(passenger.infant) {
                feeAmount += this.product.getInfantPremium();
            }

            if(feeAmount > 0) {
                const feeNote = new InsuranceFeeNote(this.product.providerCode, this.product.buildFeeNoteParts()).toString();
                const existingFee = passenger.fees.find(f => f.feeCode === this.product.feeCode && f.note === feeNote) ?? null;
                //feeAmount = Math.min(feeAmount, remainingPremiumAmount);
                feesToAdd.push({
                    passengerKey: passenger.passengerKey,
                    amount: feeAmount,
                    note:  feeNote,
                    existingFee: existingFee
                });

                //remainingPremiumAmount -= feeAmount;
            }
        }

        return feesToAdd;
    }

    private _getInsuranceSsrs(): IDotRezSsrToAdd[] {
        const ssrsToAdd: IDotRezSsrToAdd[] = [];

        for(let passengerSegment of this.booking.getAllFilteredPassengersSegments()) {

            const ssrEditor = passengerSegment.getSsr(this.product.ssrCode);
            if(ssrEditor.currentQuantity === 0) {
                const ssrToAdd = ssrEditor.createSsrToAddRequest(1);
                if(ssrToAdd) {
                    ssrEditor.newQuantity = 1;
                    ssrsToAdd.push(ssrToAdd);
                }
            }

        }

        return ssrsToAdd;

    }


    async _runMutation(): Promise<IDotRezPartialBookingSessionData> {

        const ssrsToAdd = this._getInsuranceSsrs();

        if(ssrsToAdd.length > 0) {
            await this.session.addSsrs(ssrsToAdd);
        }

        const insuranceFees = this._getInsuranceFees();
        const insuranceFeesToAdd = insuranceFees.filter(f => !f.existingFee);
        const insuranceFeesToUpdate = insuranceFees.filter(f => f.existingFee);

        for(let fee of insuranceFeesToAdd) {
            await this.services.airlineWebapi.createBookingFee({
                dotRezToken: this.session.token,
                passengerKey: fee.passengerKey,
                feeCode: this.product.feeCode,
                note: fee.note
            });
        }

        const feeOverridesRequests: IBookingMultipleFeesOverrideRequest["fees"] = [];

        if(insuranceFeesToAdd.length > 0) {
            const bookingState = await this.booking.session.bookingStateQueryBuilder().useBookingData().getBookingState();
            this.booking.updateBookingSessionData(bookingState);
            for(let feeToAdd of insuranceFeesToAdd) {
                const passenger = this.booking.passengers.getByPassengerKey(feeToAdd.passengerKey);
                const passengerFee = passenger.fees.find(f => f.feeCode === this.product.feeCode && f.note === feeToAdd.note);
                if(passengerFee) {
                    feeOverridesRequests.push({
                        feeKey: passengerFee.feeKey,
                        amount: feeToAdd.amount
                    });
                }
            }
        }

        for(let feeToUpdate of insuranceFeesToUpdate) {
            if(feeToUpdate.existingFee && feeToUpdate.existingFee.currentPrice.amount !== feeToUpdate.amount) {
                feeOverridesRequests.push({
                    feeKey: feeToUpdate.existingFee.feeKey,
                    amount: feeToUpdate.amount
                });
            }
        }


        if(feeOverridesRequests.length > 0) {
            await this.services.airlineWebapi.overrideBookingMultipleFees({
                dotRezToken: this.session.token,
                fees: feeOverridesRequests
            });
        }

        return await this.booking.session.bookingStateQueryBuilder().useBookingData().getBookingState();
    }

}
